export default __webpack_public_path__ + "static/media/breadx.1c9247f3.jpg";